module.exports = __webpack_public_path__ + "static/media/shipped_512.6a01ad65.png";